module.exports = __webpack_public_path__ + "gold-medal-a75c70ba9a80854781aaf82f708e14dd.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/gold-medal.png
// module id = 6qfh
// module chunks = client